import {ActionReducer, ActionReducerMap, createFeatureSelector} from '@ngrx/store';
import * as fromStore from '../reducers/store.reducer';
import {combineReducers} from '@ngrx/store';

export interface StoresState {
  stores: fromStore.StoreState;
}

export const reducers: ActionReducerMap<StoresState> = {
  stores: fromStore.reducer,
};

export const reducer: ActionReducer<StoresState> = combineReducers(reducers);

export const getStoresState = createFeatureSelector<StoresState>('brandsFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store/reducers/index.ts